// Mask for the forecast layer only (not the backdrop/grid) under the rail layout's floating
// question.

/** Opacity of timeline content inside the question band (faded out by 75%). */
export const FADED_ALPHA = 0.25;
/** The band extends this fraction of the question's height below it. */
export const BAND_EXTRA = 0.1;
/** The feather back to full opacity spans this fraction of the question's height… */
export const FEATHER_FRACTION = 0.5;
/** …and never less than this many px. */
export const MIN_FEATHER_PX = 12;
/** CSS variable carrying the scroll container's scrollTop, so the mask can stay screen-fixed. */
export const SCROLL_VAR = "--qfade-scroll";

/**
 * CSS mask gradient for the forecast layer, from the question's top and bottom in the scroll
 * container's local px (0 = its top edge). The layer scrolls, so every stop adds
 * `var(--qfade-scroll)` (the container's scrollTop) to stay pinned to the screen. Null when
 * there is no question.
 *
 * @param {{ top: number, bottom: number } | null | undefined} question
 * @returns {string | null}
 */
export function questionFadeGradient(question) {
  if (!question) return null;
  const height = question.bottom - question.top;
  if (!(height > 0) || !Number.isFinite(question.bottom)) return null;
  const bandEnd = Math.round(question.bottom + BAND_EXTRA * height);
  const featherEnd = bandEnd + Math.round(Math.max(MIN_FEATHER_PX, FEATHER_FRACTION * height));
  const faded = `rgba(0,0,0,${FADED_ALPHA})`;
  const at = (px) => `calc(var(${SCROLL_VAR}, 0px) + ${px}px)`;
  return `linear-gradient(to bottom, ${faded} 0, ${faded} ${at(bandEnd)}, #000 ${at(featherEnd)})`;
}
